export default "__VITE_ASSET__DRTcWa_z__"